'use strict'

import axios from "axios";
import Pagination from "./pagination";
import Grid from "./grid";
import PopinManager from "./popinManage";
import Panier from "./panier";
import Tracking from "./tracking";

// Image par défaut pour les cartes quand il n'y a pas d'image ou pas de sizes
const DEFAULT_IMAGE_CARD = '/wp-content/themes/fondation-arc/img/default.webp';

const APIList = {
    el: null,
    getDatas: function () {
        APIList.el = document.querySelector('.c-listCards');
        if (APIList.el) {

            const container = APIList.el.querySelector('.c-listCards__container');

            if (container) {
                const api = APIList.el.dataset.api;

                if (api) {
                    const isPublicationsTpl = document.querySelector('.tpl-publications');
                    const isSearchTpl = document.querySelector('.tpl-search');
                    let containerInitial = null;
                    let containerSearch = null;
                    const pageType = Tracking.getPageType();
                    // Show loader
                    if (isPublicationsTpl) {
                        containerInitial = APIList.el.querySelector('.c-listCards__container.initial');
                        containerSearch = APIList.el.querySelector('.c-listCards__container.search');
                        containerInitial.classList.add('loading');
                        containerSearch.classList.add('loading');
                    } else {
                        container.classList.add('loading');
                    }

                    const top = APIList.el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({top, behavior: "smooth"});

                    const method = APIList.el.dataset.method ? APIList.el.dataset.method : 'get';
                    const idPage = APIList.el.dataset.idPage;
                    let params = {};

                    const urlParams = new URLSearchParams(window.location.search);
                    urlParams.forEach((value, key) => {
                        params[key] = value;
                    });

                    const formattedParams = Object.keys(params)
                        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
                        .join('&');

                    const paginationCtn = APIList.el.querySelector('.c-pagination');
                    const noItemsText = APIList.el.dataset.noitems;
                    const errorText = APIList.el.dataset.error;

                    if(isPublicationsTpl && !formattedParams.includes('search_keywords')){
                        containerInitial.classList.remove('loading');
                        containerSearch.classList.remove('loading');
                        APIList.el.classList.remove('results--');
                        containerSearch.innerHTML = "";
                        return;
                    }
                    // PopinManager.destroy();

                    axios({
                        method: method,
                        url: `${api}?id_page=${idPage}&${formattedParams}`,
                    }).then(function (response) {
                            // console.log('response', response);
                            // Hide loader
                            if (isPublicationsTpl) {
                                containerInitial.classList.remove('loading');
                                containerSearch.classList.remove('loading');
                            } else {
                                container.classList.remove('loading');
                            }
                            if (response.status === 200) {
                                const {data: {items, pagination}} = response.data;
                                // Update list container
                                if (isPublicationsTpl) {
                                    APIList.el.classList.add('results--');
                                    containerSearch.innerHTML = "";
                                } else {
                                    container.innerHTML = "";
                                }
                                if (items && items.length > 0) {
                                    items.forEach((item, index) => {
                                        switch (item.type) {
                                            case 'actualite':
                                            case 'defi':
                                            case 'cancer':
                                            case 'projet_soutenu':
                                            case 'page':
                                                container.append(APIList.createCardActu(item, pageType, index+1));
                                                break;
                                            case 'projet':
                                                container.append(APIList.createCardProject(item, pageType, index+1));
                                                break;
                                            case 'publication':
                                                if (isPublicationsTpl) {
                                                    containerSearch.append(APIList.createCardPublicationLarge(item, pageType, index+1));
                                                } else {
                                                    container.append(APIList.createCardPublication(item, pageType, index));
                                                }
                                                break;
                                            case 'chercheur':
                                                container.append(APIList.createCardChercheur(item));
                                                break;
                                            case 'video':
                                                container.append(APIList.createCardVideoFull(item));
                                                break;
                                            case 'faq':
                                                container.append(APIList.createCardVideoLight(item));
                                                break;
                                        }
                                    });
                                    // restore PopinVideo
                                    PopinManager.init();
                                } else {
                                    if (isPublicationsTpl) {
                                        if (containerSearch) {
                                            const newContainer = document.createElement('div');
                                            newContainer.className = 'c-listCards__container search';
                                            newContainer.innerHTML = `<p>${noItemsText ? noItemsText : 'Aucune donnée à afficher'}</p>`;
                                            containerSearch.parentNode.replaceChild(newContainer, containerSearch);
                                        }
                                    } else {
                                        if (container) {
                                            const newContainer = document.createElement('div');
                                            newContainer.className = 'c-listCards__container';
                                            if (isSearchTpl) {
                                                newContainer.className = 'c-listCards__container grid';
                                            }
                                            newContainer.innerHTML = `<p>${noItemsText ? noItemsText : 'Aucune donnée à afficher'}</p>`;
                                            container.parentNode.replaceChild(newContainer, container);
                                        }
                                    }

                                }
                                // Update masonry grid
                                if (isSearchTpl) {
                                    Grid.init();
                                }
                                // Update pagination
                                if (paginationCtn) {
                                    paginationCtn.innerHTML = pagination;
                                    Pagination.init(); // reset elements to addEventListener click
                                }
                            } else {
                                console.log('errors', response.statusText);
                                // Update list container // Add error message
                                if (isPublicationsTpl) {
                                    if (containerSearch) {
                                        const newContainer = document.createElement('div');
                                        newContainer.className = 'c-listCards__container search';
                                        newContainer.innerHTML = `<div class="error global--">${errorText ? errorText : 'Une erreur est survenue. Veuillez réessayer ultérieurement.'}</div>`;
                                        containerSearch.parentNode.replaceChild(newContainer, containerSearch);
                                    }
                                } else {
                                    if (container) {
                                        const newContainer = document.createElement('div');
                                        newContainer.className = 'c-listCards__container';
                                        newContainer.innerHTML = `<div class="error global--">${errorText ? errorText : 'Une erreur est survenue. Veuillez réessayer ultérieurement.'}</div>`;
                                        container.parentNode.replaceChild(newContainer, container);
                                    }
                                }
                                // Update pagination
                                if (paginationCtn) {
                                    paginationCtn.innerHTML = '';
                                }
                            }
                        }
                    ).catch(function (response) {
                        console.log('err', response);
                        // Update list container // Add error message
                        if (isPublicationsTpl) {
                            if (containerSearch) {
                                const newContainer = document.createElement('div');
                                newContainer.className = 'c-listCards__container search';
                                newContainer.innerHTML = `<div class="error global--">${errorText ? errorText : 'Une erreur est survenue. Veuillez réessayer ultérieurement.'}</div>`;
                                containerSearch.parentNode.replaceChild(newContainer, containerSearch);
                            }
                        } else {
                            if (container) {
                                const newContainer = document.createElement('div');
                                newContainer.className = 'c-listCards__container';
                                newContainer.innerHTML = `<div class="error global--">${errorText ? errorText : 'Une erreur est survenue. Veuillez réessayer ultérieurement.'}</div>`;
                                container.parentNode.replaceChild(newContainer, container);
                            }
                        }
                        // Update pagination
                        if (paginationCtn) {
                            paginationCtn.innerHTML = '';
                        }
                    });
                }
            }
        }
    },
    generateImageMarkup: function (image, format) {
        // Vérifier si on a une image avec des sizes
        if (image && image.sizes) {
            const image_desktop = image.sizes[format + '-desktop'] ?? image.url;
            const image_desktop_retina = image.sizes[format + '-desktop-retina'] ?? image.url;
            const image_mobile_retina = image.sizes[format + '-mobile-retina'] ?? image.url;
            const image_width = image.sizes[format + '-desktop-width'] ?? image.width;
            const image_height = image.sizes[format + '-desktop-height'] ?? image.height;

            const ctn = document.createElement('div');
            ctn.role = "figure";
            ctn.classList.add('figure');
            if (image.caption) {
                ctn.setAttribute('aria-label', image.caption);
            }
            let alt = ""
            if (image.alt) {
                alt = ' alt="' + image.alt + '"';
            } else {
                alt = ' aria-hidden="true"';
            }

            ctn.innerHTML = ` 
                <picture>
                    <source media="(min-width: 1240px)" srcset="${image_desktop} 1x, ${image_desktop_retina} 2x">
                    <source media="(min-width: 450px)" srcset="${image_mobile_retina}">
                    <img loading="lazy" src="${image_desktop}"${alt} width="${image_width}" height="${image_height}"/>
                </picture>
            `;

            return ctn;
        }

        // Fallback : image générique quand pas d'image ou pas de sizes
        const ctn = document.createElement('div');
        ctn.role = "figure";
        ctn.classList.add('figure');
        ctn.innerHTML = `<img loading="lazy" src="${DEFAULT_IMAGE_CARD}" aria-hidden="true" />`;
        return ctn;

    },
    createCardActu: function ({permalink, image, date, title, tags, with_video, type}, pageType, index) {
        const card = document.createElement('li');
        card.className = 'c-cardActu c-card';

        const tagsContainer = tags && tags.length > 0 ? `<div class="c-tags">${tags.map(tag => `<span>${tag.name}</span>`).join('')}</div>` : '';
        const videoPlayer = with_video === 'yes' ? `<div class="c-buttonPlay small--"></div>` : '';

        // Content
        const ctaId = pageType === 'recherche' ? `${pageType}-${type}-${index}`: `${pageType}-${index}`;
        const contentContainer = document.createElement('div');
        contentContainer.className = 'c-cardActu__content';
        contentContainer.innerHTML += `<div class="h4">${title}</div>
                        ${tagsContainer}
            <a href="${permalink || '#'}" class="c-buttonIcon" data-track-cta data-cta-type="card" data-cta-position="${pageType}" data-cta-id="${ctaId}"><i aria-hidden="true" class="icon-arrow-large"></i><span class="visuallyHidden">En savoir plus sur ${title}</span></a>`;
        card.appendChild(contentContainer);

        // Image
        const imgContainer = document.createElement('div');
        imgContainer.className = 'c-cardActu__img';
        if (image) {
            const img = APIList.generateImageMarkup(image, 'slider-push');
            if(img) imgContainer.appendChild(img);
        }
        if (date) {
            imgContainer.innerHTML += `<div class="c-cardActu__date">${date}</div>`;
        }
        imgContainer.innerHTML += videoPlayer;
        card.appendChild(imgContainer);

        return card;
    },
    createCardChercheur: function ({id, picture, title, chapo, border_color, api_url}) {
        const card = document.createElement('li');
        card.className = `c-cardChercheur c-card ${border_color}`;
        card.dataset.api = `${api_url}`;

        // Content
        const contentContainer = document.createElement('div');
        contentContainer.className = 'c-cardChercheur__content';
        contentContainer.innerHTML += `
            <h4 class="h4">${title}</h4>
            <div class="c-cardChercheur__content-flex">
                <p class="c-cardChercheur__title">${chapo}</p>
                <button class="c-buttonIcon popinChercheur--"><i aria-hidden="true" class="icon-arrow-large"></i><span class="visuallyHidden">En savoir plus sur ${title}</span></button>
            </div>
    `;
        card.appendChild(contentContainer);

        // Image
        const img = APIList.generateImageMarkup(picture, 'chercheur');
        const imgContainer = document.createElement('div');
        imgContainer.className = 'c-cardChercheur__img';
        imgContainer.appendChild(img);
        card.appendChild(imgContainer);
        return card;
    },
    createCardVideoLight: function ({id_youtube, title, border_color, picture, text}) {
        const card = document.createElement('li');
        card.className = 'c-card c-cardVideoLight';
        const cardButton = document.createElement('button');
        cardButton.className = 'popinVideo--';
        cardButton.setAttribute('data-id', id_youtube);
        cardButton.setAttribute('data-title', title);

        // Content
        const contentContainer = document.createElement('h3');
        contentContainer.className = 'h4';
        contentContainer.innerHTML = text;

        cardButton.append(contentContainer);

        // Image
        const imgContainer = document.createElement('div');
        imgContainer.className = `c-cardVideoLight__img ${border_color}`;
        const img = APIList.generateImageMarkup(picture, 'auteur');
        imgContainer.appendChild(img);

        // Play
        const playIcon = document.createElement('div');
        playIcon.className = 'c-buttonPlay xsmall-- rounded--';
        imgContainer.appendChild(playIcon);

        cardButton.append(imgContainer);

        card.append(cardButton);

        return card;
    },
    createCardVideoFull: function ({id_youtube, title, poster_image, text, author_firstname, author_lastname, job_position}) {
        const card = document.createElement('li');
        card.className = 'c-card c-cardVideoFull';
        card.style.backgroundImage = `url('${poster_image.url}')`;
        const cardButton = document.createElement('button');
        cardButton.className = 'popinVideo--';
        cardButton.setAttribute('data-id', id_youtube);
        cardButton.setAttribute('data-title', title);

        cardButton.innerHTML = `
        <h3 class="c-cardVideoFull__title">${text}</h3>
        <div class="c-cardVideoFull__author">
            <span>${author_lastname}</span>
            <span>${author_firstname}</span>
            <span class="function--">${job_position}</span>
        </div>
         <div class="c-buttonPlay"></div>
    `;
        card.append(cardButton);

        return card;
    },
    createCardProject: function ({permalink, image, closed_date, color, status, title, type}, pageType, index) {
        const card = document.createElement('li');
        card.className = `c-cardProject c-card ${color}`;
        // Content
        const ctaId = pageType === 'recherche' ? `${pageType}-${type}-${index}`: `${pageType}-${index}`;
        const contentContainer = document.createElement('div');
        contentContainer.className = 'c-cardProject__content';
        contentContainer.innerHTML += `<div class="h5">${title}</div>
            <a href="${permalink || '#'}" class="c-buttonIcon" data-track-cta data-cta-type="card" data-cta-position="${pageType}" data-cta-id="${ctaId}"><i aria-hidden="true" class="icon-arrow-large"></i><span class="visuallyHidden">En savoir plus sur ${title}</span></a>`;
        card.appendChild(contentContainer);

        // Intro
        const introContainer = document.createElement('div');
        introContainer.className = 'c-cardProject__intro';
        introContainer.innerHTML += ` <div class="c-cardProject__intro-title">${status}</div>
                                <p>Date de limite de remise des dossiers :<br><strong>${closed_date}</strong></p>`;
        card.appendChild(introContainer);

        // Image
        const img = APIList.generateImageMarkup(image, 'slider-push');
        const imgContainer = document.createElement('div');
        imgContainer.className = 'c-cardProject__img';
        imgContainer.appendChild(img);

        card.appendChild(imgContainer);

        return card;
    },
    createCardPublication: function ({id, image, title, subtitle, file, is_orderable, type_publication, collection, edition, max_order}, pageType, index) {
        const card = document.createElement('li');
        card.className = 'c-cardBrochure c-card';
        // Content
        const contentContainer = document.createElement('div');
        contentContainer.className = 'c-cardBrochure__content';
        contentContainer.innerHTML += `<div class="c-cardBrochure__content-text">
                                      <div class="h5">${title}</div>
                                      <div class="c-cardBrochure__content-type">${collection}</div>
                                      <p>${subtitle}</p>
                                      </div>
                                  `;


        // Image
        const img = APIList.generateImageMarkup(image, 'thumbnail-publication');
        const imgContainer = document.createElement('div');
        imgContainer.className = 'c-cardBrochure__content-img';
        // imgContainer.title = title;
        imgContainer.appendChild(img);

        const editionTag = document.createElement('div');
        editionTag.className = "c-cardBrochure__content-tag";
        editionTag.innerHTML = edition;
        imgContainer.append(editionTag);

        contentContainer.append(imgContainer)
        card.appendChild(contentContainer);

        if (type_publication) {
            const tagsContainer = document.createElement('div');
            tagsContainer.className = 'c-tags';
            tagsContainer.innerHTML = `<span>${type_publication}</span>`;
            card.appendChild(tagsContainer);
        }

        const buttonCards = document.createElement('div');
        buttonCards.className = 'c-buttonsCards';
        const download = document.createElement('a');
        download.href = file.url;
        download.className = 'c-buttonCard';
        download.download = true;
        download.dataset.trackCta = true;
        download.dataset.ctaType = "telechargement";
        download.dataset.ctaPosition = pageType;
        download.dataset.ctaId = pageType+'-publication-'+index;
        download.dataset.title = file.title;
        download.dataset.type = type_publication || '';
        download.innerHTML = `
            <span class="c-buttonCard__text">
                Télécharger<span class="visuallyHidden"> ${title}</span>
                <span>(${file.ext} - ${file.size})</span> 
            </span>
            <i aria-hidden="true" class="icon-download"></i>
        `;
        buttonCards.append(download);
        if (is_orderable) {
            const cart = document.createElement('button');
            cart.className = 'c-buttonCard addToCart';
            cart.dataset.idPublication = id;
            cart.dataset.titlePublication = title;
            cart.dataset.imagePublication = image.sizes['thumbnail-publication-solo'];
            cart.dataset.maxOrderPublication = max_order;
            cart.dataset.ctaPosition = pageType+'-publication-'+index;
            cart.dataset.ctaId = pageType+'-publication-order-'+index;
            cart.dataset.typePublication = type_publication;
            cart.dataset.editionPublication = edition || '';
            cart.innerHTML = `
             <span class="c-buttonCard__text">
                Commander<span class="visuallyHidden"> ${title}</span>
                <span>Gratuitement</span>
            </span>
            <i aria-hidden="true" class="icon-book"></i>
        `;
            buttonCards.append(cart);
        }
        card.append(buttonCards);

        return card;
    },
    createCardPublicationLarge: function ({id, permalink, image, title, subtitle, file, is_orderable, type_publication, edition, max_order}, pageType, index) {
        const card = document.createElement('li');
        card.className = 'c-cardBrochure c-card compact';
        // Content
        const contentContainer = document.createElement('div');
        contentContainer.className = 'c-cardBrochure__content-text';
        contentContainer.innerHTML += `
                                      <div class="h4 c-cardBrochure__content-title">${title}</div>
                                       <div class="c-tags"><span>${type_publication}</span></div>
                                  `;

        if(subtitle){
            contentContainer.innerHTML+= `<p>${subtitle}</p>`;
        }
        const buttonCards = document.createElement('div');
        buttonCards.className = 'c-buttonsCards';
        const download = document.createElement('a');
        download.href = file.url;
        download.className = 'c-buttonCard';
        download.download = true;
        download.dataset.trackCta = true;
        download.dataset.ctaType = "telechargement";
        download.dataset.ctaPosition = pageType;
        download.dataset.ctaId = pageType+'-publication-'+index;
        download.dataset.title = file.title;
        download.dataset.type = type_publication || '';
        download.innerHTML = `
            <span class="c-buttonCard__text">
                Télécharger<span class="visuallyHidden"> ${title}</span>
                <span>(${file.ext} - ${file.size})</span> 
            </span>
            <i aria-hidden="true" class="icon-download"></i>
        `;
        buttonCards.append(download);
        if (is_orderable) {
            const cart = document.createElement('button');
            cart.className = 'c-buttonCard addToCart';
            cart.dataset.idPublication = id;
            cart.dataset.titlePublication = title;
            cart.dataset.imagePublication = image.sizes['thumbnail-publication-solo'];
            cart.dataset.maxOrderPublication = max_order;
            cart.dataset.ctaPosition = pageType;
            cart.dataset.ctaId = pageType+'-publication-order-'+index;
            cart.dataset.typePublication = type_publication;
            cart.dataset.editionPublication = edition || '';
            cart.innerHTML = `
             <span class="c-buttonCard__text">
                Commander<span class="visuallyHidden"> ${title}</span>
                <span>Gratuitement</span>
            </span>
            <i aria-hidden="true" class="icon-book"></i>
        `;
            buttonCards.append(cart);
        }
        contentContainer.append(buttonCards);
        card.append(contentContainer)

        // Image
        const img = APIList.generateImageMarkup(image, 'thumbnail-publication');
        const imgContainer = document.createElement('div');
        imgContainer.className = 'c-cardBrochure__content-img';

        if (permalink) {
            const imgLink = document.createElement('a');
            imgLink.href = permalink;
            imgLink.className = 'c-cardBrochure__content-img-link';
            imgLink.setAttribute('aria-label', 'Voir la publication');
            imgLink.appendChild(img);
            imgContainer.appendChild(imgLink);
        } else {
            imgContainer.appendChild(img);
        }

        card.append(imgContainer);

        return card;
    },
}

export default APIList;